module.exports = __webpack_public_path__ + "static/media/Veeru.07adef4a.png";